import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10","key":"svg-0"}],["path",{"d":"M12 10v-7","key":"svg-1"}]]

/**
 * IconGenderNeutrois
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZ2VuZGVyLW5ldXRyb2lzIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiAxMGE1IDUgMCAxIDEgMCAxMGE1IDUgMCAwIDEgMCAtMTAiIC8+CiAgPHBhdGggZD0iTTEyIDEwdi03IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/gender-neutrois
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconGenderNeutrois = createReactComponent('outline', 'gender-neutrois', 'GenderNeutrois', __iconNode);

export default IconGenderNeutrois;